import { Fragment, useEffect, useState } from "react";
import HeaderSection from "../header/header.component";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { BsSearch, BsXLg } from "react-icons/bs";
import { FETCH_REPORT_LIST } from "../../services/graphql/report";
import { useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import ReportListCard from "../report-list-card/report-list-card.component";

const PAGE_SIZE_FOR_SALES_LIST = 15;

const ReportList = () => {
  const businesprofile = useSelector((state) => state.businesprofile);
  const lastSavedData = useSelector((state) => state.sales);
  const [search, setSearch] = useState(
    lastSavedData ? lastSavedData.search : ""
  );
  const [reportList, setReportList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [type, setType] = useState(
    lastSavedData ? lastSavedData.type : "Product"
  );
  const totalPages = Math.ceil(totalCount / PAGE_SIZE_FOR_SALES_LIST);

  const [page, setPage] = useState(lastSavedData ? lastSavedData.page : 1);

  // Fetch data from the GraphQL server
  const { loading, data } = useQuery(FETCH_REPORT_LIST, {
    variables: {
      providerId: businesprofile._id,
      type: type === "Subscription" ? "autoship" : type,
      search,
      page,
      pageSize: PAGE_SIZE_FOR_SALES_LIST,
    },
    fetchPolicy: "no-cache"
  });

  useEffect(() => {
    if (data) {
      const { fetchReportList } = data;
      const { totalCount, reports } = fetchReportList;
      setTotalCount(totalCount);
      setReportList(reports);
    }
  }, [data]);

  return (
    <div className="main-div-right-section">
      <Fragment>
        <HeaderSection currentTab={"Sales"} />
        <div className="second-section-style">
          <Fragment>
            <Row>
              <Col
                lg="10"
                md="8"
                sm="6"
                xs="6"
                style={{
                  paddingLeft: "0px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "22px", fontWeight: "bold" }}>
                  Reports
                </label>
              </Col>
            </Row>
            <div style={{ marginTop: "3%" }}>
              <Row>
                <Col lg="3" md="3" sm="2" xs="2" style={{ paddingLeft: "0px" }}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <InputGroup
                      style={
                        totalCount === 0 && search === ""
                          ? { backgroundColor: "lightgrey" }
                          : { backgroundColor: "white" }
                      }
                    >
                      <BsSearch color="#7d7d7d" />
                      <Form.Control
                        type="text"
                        style={
                          totalCount === 0 && search === ""
                            ? { backgroundColor: "lightgrey" }
                            : { backgroundColor: "white" }
                        }
                        disabled={totalCount === 0 && search === ""}
                        placeholder="Search ID, client name...."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      {search ? (
                        <BsXLg
                          onClick={() => {
                            setSearch("");
                          }}
                          color="#7d7d7d"
                        />
                      ) : null}
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {/* Report list */}
            <ReportListCard
              totalCount={totalCount}
              reportList={reportList}
              page={page}
              type={type}
              setType={setType}
              setPage={setPage}
              totalPages={totalPages}
              pageSize={PAGE_SIZE_FOR_SALES_LIST}
              loading={loading}
              search={search}
              dropDownValue={["Product", "Service", "Subscription"]}
            />
          </Fragment>
        </div>
      </Fragment>
    </div>
  );
};

export default ReportList;
